module.exports = __webpack_public_path__ + "img/special-notice-icon.svg";